export const FETCH_EL_VOICES_REQUEST = "FETCH_EL_VOICES_REQUEST";
export const FETCH_EL_VOICES_SUCCESS = "FETCH_EL_VOICES_SUCCESS";
export const FETCH_EL_VOICES_FAILURE = "FETCH_EL_VOICES_FAILURE";
